var fvChannel = require('glRadio').channel('FV');

/*
* Context is viewer.
* Many of these have links to this.state
* Note: events triggered from external modules -- forward to inner
* TODO: clean -- state now forwarded through channel and channel via viewer;
* vChannelEvents -->  channel
* NOTE: the function name MUST be the event that triggers it -- no longer secoNdary XREF !
* the fn NAMES are the EVENT names
* Here to be backwards compatible with the old events triggered off 'viewerModel' (state)
* TODO: now some actions pre state api call set here -- just forward and do the actions in the api
* */


module.exports = {

    common: {

        // Main View is now not a sub app, perhaps it should be
        'alert:show': function(options) {
            this.command('mainView.showAlert', options);
        },
        'alert:hide': function() {
            this.command('mainView.hideAlert');
        },
        'modal:open': function(options, isLoading) {
            this.commandOn( 'viewModes', 'closeCanvasDialogs' );
            this.commandOn( 'layout', 'showModal', options, isLoading );

        },
        'modal:close': function() {
            this.commandOn('layout', 'closeModal');
        }

    },

    notes: {
        'notes:goToPage': function (note) {
            this.state.goToPageOfNote(note);
        },

        'notes:setActiveNote': function (note, options) {
            this.state.setActiveNote(note, options);
        },

        'notes:setExpandedNote': function (note) {
            this.state.setExpandedNote(note);
        },

        'notes:noteSaved': function (note) { //(really post save)

            if ( note.isPageNote() ) {

                // The note was already added to the allNotes collection.
                // Also add it to the pageNotes collection.
                this.request('pageNotes').add( note );

                // Also and the collection's of the page models in each 'mode'.
                // And because multiple copies of the same page can be in the same document,
                // we need to add the note for each page of the note (not just the current page).
                // Note: the pageCollection is the 'doc mode' page model.

                var pgsWithNote = this.request('activeDocPages').filter(function(p) {
                    return note.get('pageId') === p.get('pageId');
                });

                _.each( pgsWithNote, function(page) {
                    var docModePg = page,
                        thumb = this.request('getThumbFromPageModel', page);
                    _.invoke([docModePg, thumb], 'addNewPageNote', note);
                }, this);

                // For the full page model, use just the current page.
                // Only one model ever exists -- whenever a page is changed a new model is created and ,
                // it's notesCollection will be updated from the docMode page model.
                // TODO: Find and Redact: only add to the full page model if its on the current page --- may want to refactor all this to reflect ...
                if ( note.get('pageId') == this.request('currentPage').get('pageId') ) {
                    this.request('fullPageModel').addNewPageNote(note);
                }


            } else {

                this.request('docNotes').add(note, {sort: false});

            }

            //* always use the allNotes collection (flashBack notes are not tied to the collection so referencing from will err )
            this.commandOn('layout', 'updateNoteCount', this.request('allNotes').length);


            // Re-render canvas for drawable notes

            if ( note.isDrawable() ) {

                // And: trigger a re-render on the canvas of if the note is on the current page -- FIND AND REDACT
                if (note.get('pageId') == this.request('currentPage').get('pageId')) {
                    this.commandOn('viewModes', 'noteSaved', note);
                }
            }

        },

        /*
         * Note: Backbone's internals will remove the model from any of its collections on destroy --
         * ( Backbone's model.destroy triggers an event listened to by the collections: see Collection's modelEvents );
         * So we don't need to remove from page/doc notes collections, as well as all of the page model's collections.
         */
        'notes:noteDeleted': function (note) {

            this.commandOn('layout', 'updateNoteCount', this.request('allNotes').length);
            this.commandOn('viewModes', 'noteDeleted', note);

        },
        /*
         * Note: called twice from canvas (... still ? )
         */
        'notes:setNoteSubType': function () {
            this.state.set.apply(this.state, ['activeNoteSubType'].concat(_.toArray(arguments)));
        },

        'notes:newNoteMenuRendered': function () {

            this.commandOn.apply( this, ['layout', 'createNewNoteMenu'].concat(
                _.toArray(arguments)).concat([this.request('getWrapper')])
            );
        },

        'notes:setDrawColor': function (color) {
            this.commandOn('viewModes', 'setDrawColor', color);
        },
        'notes:setDrawStrokeWidth': function (width) {
            this.commandOn('viewModes', 'setStrokeWidth', width);
        },
        'notes:toggleShapeHighlight': function (note, options) {

            if (this.state.noteIsActiveOrExpanded()) {
                return false;
            }

            this.commandOn('viewModes', 'toggleHighlightedNote', note, options);

        },
        'notes:graphicStampChanged': function () {

            this.commandOn.apply(this, ['viewModes', 'graphicStampChanged'].concat(_.toArray(arguments)));

        },

        'notes:consultGroupChange': function( note ) {

            this.commandOn( 'viewModes', 'consultGroupChange', note );

        }
    },

    //NOTE: FIRE OFF THE PAGE MODEL PUT A CHANNEL ON IT? ... ????
    /* NOTE: NOW REALLY PAGE CANVAS -- there is a one to many relationship, but for the below all events would be one to one */
    /* Not making major change in the architecture so don't break -- see other branch ...*/

    canvas: {
        /* only one note can be hovered at a time, even with multi canvas' */
        'canvas:hoveredNoteChange': function () {

            if (this.state.noteIsActiveOrExpanded())  //TODO: also if panel is open
                return false;

            this.commandOn.apply(this, ['notes', 'hoveredCanvasNoteChange'].concat(_.toArray(arguments)));

        },
        /* because only one note can be edited at a time, can leave as 'many to many' */
        'canvas:drawingToggled': function () {
            this.commandOn.apply(this, ['notes', 'canvasDrawingToggled'].concat(_.toArray(arguments)));
        },

        /**
         * Because only one note can be edited at a time, can leave as 'many to many'.
         * Mediate state call
         * Note: called twice from canvas
         */
        'canvas:changeActiveNoteSubtype': function () {

            this.state.set.apply(this.state, ['activeNoteSubType'].concat(_.toArray(arguments)));
        },

        /**
         * Because only one note can be edited at a time, can leave as 'many to many'
         * Here because can cancel from button -- unlike other types.
         */
        'canvas:cancelSignature': function (noteModel) {
            this.commandOn.apply(this, ['notes', 'cancelSignature'].concat(_.toArray(arguments)));
        }

    },
    fullText: {

        'fullText:changePage': function (pgNum) {
            var pg = this.request('activeDocPages').getModelFromPgNumber(pgNum);
            // (eg page may not exist if a dummy 'meta data' page from ES module (<1) or with dummy data
            if (!pg) return;
            this.state.goToPage(pg);
        },

        'fullText:updateNoteCountAndCaption': function () {
            this.commandOn.apply(this, ['layout', 'updateFullTextNoteCountAndCaption'].concat(_.toArray(arguments)));
        }

    },

    findAndRedact: {


        /**
         * Set findAndRedactSearchModel.userClickedHitId which is picked up on canvas re-render process to select the shape.
         * userClickedHitId is cleared immediately after the reRenderShapes, so its not persisted ( this is unlike toggleExpanded )
         * So we set 'isSelected' on it and incorporate into the render process in the canvas,
         * which is also called when page/mode is causing a canvas re-render.
         */

        'findAndRedact:goToHit': function( hitModel ) {

            this.state.get('findAndRedactSearchModel').set(
                { userClickedHitId: hitModel.get('id') }, { silent: true }
            );

            // First same logic as in expanded note/active note change if could be on diff mode/page
            // Mode: still unsure if we will allow going back and forth when find and redact open ...
            var inPageMode = this.state.viewMode() === 'page';
            var onSamePage = hitModel.get('pageNumber') === this.state.currentPageNumber();

            // Re-render the shapes on the canvas; selected shapes of the hit will be picked up and
            // selected accordingly in the process
            if ( inPageMode && onSamePage ) {

                // Here could by-pass userClicked hitId and re-render process -- could use
                // var shapeOfHit = hitModel.get('shape')
                // and set it to the select shape but using the same process is cleaner.
                this.commandOn('viewModes', 'reRenderShapes');
                return;
            }

            // Workflow from expanded/active note which will ultimately result in a canvas re-render,
            // so no need to kick off the 're-render' manually.
            if ( !inPageMode ) {
                this.state.setViewMode('page');
            }

            // Last would take over the render of the canvas
            if ( !onSamePage ) {
                this.state.goToPageId( hitModel.get('pageId') );
            }

            // Old comments -- I don't think still an issue:

            // If change viewMode and page mode, createPageModeView will be kicked off twice (fast) which will call createPageModeView, which then
            // calls, renderPgModePgView --> starting the request process, which when successful, results in creating a canvas and calling 're-renderShapes'
            // this this happens so fast, re-render shapes likely cannot be called twice -- maybe we have a setViewMode which doesn't create a new page model if both will
            // be changed, or do won't about this?

            // if create and render canvas is called twice --> onBeforeDestroy will be called on the 2nd, so could 'clear' then;
            // probably safe to do after shapes have been re-rendered in the canvas module

            // Could put in logic to not create the viewMode on viewMode change callback -- but that part will go so fast I don't think we will run into issue.

        },

        'findAndReact:revertShapePosition': function(hitModel) {

            var shape = hitModel.get('shape');

            shape.set({
                points: shape.get('originalPointsInTenthsMM')
            }, {silent: true});

            // Note: floating code redaction shape models 'persisted' here --
            // in the call 'points' are set to 'points', not taking from the DOM, so this now works
            this.commandOn('viewModes', 'reRenderShapes');

            // Trigger back on the hit view
            shape.uiModel.set('isDirty', false);

        },

        'findAndRedact:hitShapeReasonCodesChange': function( shape, aCodes, fromSelectAllOrClear ) {

            if ( !shape.parentNote.isFloatingRedaction() ) {
                updateShapeModelsReasonCodeCollection();
                return;
            }

            // Floating Redaction:
            // Set for page change and mode change ( when canvas has loaded )
            // -- want to draw from 'default position' to get new size of box.

            shape.setBoxIsDirty(true);

            // 'Show' the page mode view so size of the box can be calculated (it can't is hidden via css)
            // Only do if page had already loaded, where a re-render wouldn't have been called
            // ( If not yet rendered, they will be put at default position in that mode )
            var toggleVisibilityOfPageMode =
                this.request('viewMode') !== 'page' && this.request('fullPageModel').get('isLoaded');

            if (toggleVisibilityOfPageMode) {
                this.commandOn('viewModes', 'toggleForceDerivisionOfPageModeDomElements', 1);
            }

            updateShapeModelsReasonCodeCollection();

            // Set back page mode css / visibility
            if (toggleVisibilityOfPageMode) {
                this.commandOn('viewModes', 'toggleForceDerivisionOfPageModeDomElements', 0);
            }


            function updateShapeModelsReasonCodeCollection() {

                if ( !fromSelectAllOrClear ) {
                    shape.colRedactionCodes.set( aCodes, {sourceNotFromChosen: 1 });
                } else {
                    shape.colRedactionCodes.reset( aCodes, {sourceNotFromChosen: 1 });
                }

            }

        },
        /* Without changes to Canvas:HoverEdit Dialog -- make sure find and redact and zone dialgos aren't open at the same time */
        /* This will prevent our having to keep them in sync if any 2 are open */
        /* Workaround for the hover edit dialog not being a regular dropdown */
        /* Will also need to implement the other way around ( canvas to find and redact ) -- now called directly on the shape model
         * -- we could do that here too but instead utilizing existing closeCanvasDialogs */
        'findAndRedact:openHitShapeDialog': function( shape ) {
            this.commandOn( 'viewModes', 'closeCanvasDialogs' );

        }

    }

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/channel/subscriptionCallbacks.js
 ** module id = 105
 ** module chunks = 0
 **/